
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[siteHandle]/[...uri]",
      function () {
        return require("private-next-pages/[siteHandle]/[...uri].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[siteHandle]/[...uri]"])
      });
    }
  